
(function() { 
  $(function(){
    $.fn.getComments = function () {
        return this.contents().map(function () {
            if (this.nodeType === 8) return this;
        }).get();
    };

      $('<div class="Splited-text SectionHeader__Description Rte">').css({'text-align': 'center', 'margin': '0 auto'}).appendTo('.CollectionInner__Products');
          var index = $($('.SectionHeader__Description.Rte, .SectionHeader__Description.Rte > div').getComments()).index();
          $('.SectionHeader__Description.Rte > div > *, .SectionHeader__Description.Rte > *:not(div)').each(function(i){
              if (i >= index) $(this).appendTo('.Splited-text');
      });

    if (typeof Yotpo !== 'undefined') {
      yotpo.on('ready', function() {
        $('.yotpo.bottomLine').each(function(){
          var $this = $(this);

          if (!$this.has('.standalone-bottomline').length) {
          	$this.find('.yotpo-display-wrapper').prepend(
            	'<div class="standalone-bottomline" data-source="offload">'+
              		'<div class="yotpo-bottomline pull-left star-clickable" tabindex="0">'+
              			'<span class="yotpo-stars">'+
              				'<span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>'+
              				'<span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>'+
              				'<span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>'+
              				'<span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>'+
              				'<span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>'+
              				'<span class="sr-only">0.0 star rating</span>'+
              			'</span>'+
              			'<a class="text-m write-review-btn-hidden">Write a review</a>'+
              			'<div class="yotpo-clr"></div>'+
              		'</div>'+ 
              		'<div class="yotpo-clr"></div>'+ 
              	'</div>'  
            );
          }
        });
      }); 
    }
  });
})();

var CustomJS = {};

CustomJS.SizeChart = (function () {
	function getDesigner () {
		var path = location.pathname
		var substring = '/products/'
		if (path.indexOf(substring) === -1) return false
		var designerUrlPart = path.split(substring)[1]
		var designer = designerUrlPart.substring(0, designerUrlPart.lastIndexOf('-'))
		return designer
	}

	function getChart (designer) {
		var db = CustomDB.SizeChart
		for (var key in db) {
			if (db.hasOwnProperty(key) && key === designer) {
				var chart = []
				db[key].forEach(function (row) {
					var parts = row.split('/')
					chart.push({
						size: parts[0],
						bust: parts[1],
						waist: parts[2],
						hip: parts[3]
					})
				})
				return chart
			}
		}
		return false
	}

	function getHtml (designer, chart, unit) {
		var tableContent = ''
		chart.forEach(function (row) {
			tableContent +=
				'<tr>' +
					'<td class="SizeChart__cell SizeChart__cell_size" data-size="' + row.size + '">' + row.size + '</td>' +
					'<td class="SizeChart__cell SizeChart__cell_bust" data-inches="' + row.bust + '">' + row.bust + '</td>' +
					'<td class="SizeChart__cell SizeChart__cell_waist" data-inches="' + row.waist + '">' + row.waist + '</td>' +
					'<td class="SizeChart__cell SizeChart__cell_hip" data-inches="' + row.hip + '">' + row.hip + '</td>' +
				'</tr>'
		})
		return '' +
			'<div class="SizeChart" data-unit="' + unit + '">' +
				'<div class="SizeChart__top">' +
					'<div class="SizeChart__inputs">' +
						'<input class="SizeChart__input SizeChart__input_bust" type="text" placeholder="Bust" autofocus>' +
						'<input class="SizeChart__input SizeChart__input_waist" type="text" placeholder="Waist">' +
						'<input class="SizeChart__input SizeChart__input_hip" type="text" placeholder="Hip">' +
					'</div>' +
					'<div class="SizeChart__recommendation">' +
						'Based on your measurements we recommend ordering size <span></span>' +
					'</div>' +
				'</div>' +
				'<div class="SizeChart__designer">' + designer.replace(/-/g, ' ') + ' Size&nbsp;Chart</div>' +
				'<table class="SizeChart__table">' +
					'<thead>' +
						'<tr>' +
							'<th><center>Size</th>' +
							'<th>Bust (<span></span>)</th>' +
							'<th>Waist (<span></span>)</th>' +
							'<th>Hip (<span></span>)</center></th>' +
						'</tr>' +
					'</thead>' +
					'<tbody>' + tableContent + '</tbody>' +
				'</table>' +
				'<div class="SizeChart__convert">' +
					'<button></button>' +
					'<span></span>' +
				'</div>'
			'</div>'
	}

	function convertInchToCm (inch) {
		return Math.round(inch * 2.54)
	}

	function convert () {
		var unitCurrent = $('.SizeChart').data('unit')
		var unitNext = ''
		var unitCurrentName = ''
		var unitNextName = ''
		switch (unitCurrent) {
			case 'cm':
				unitNext = 'inch'
				unitCurrentName = 'Inches'
				unitNextName = 'Centimeters'
				$('.SizeChart__table td[data-inches]').each(function () {
					var $this = $(this)
					$this.text($this.data('inches'))
				})
				break
			case 'inch':
				unitNext = 'cm'
				unitCurrentName = 'Centimeters'
				unitNextName = 'Inches'
				$('.SizeChart__table td[data-inches]').each(function () {
					var $this = $(this)
					$this.text(Math.round($this.data('inches')*2.54))
					$this.text(convertInchToCm($this.data('inches')))
				})
				break
			default:
				break
		}
		$('.SizeChart').data('unit', unitNext)
		$('.SizeChart__input').val('')
		$('.SizeChart__input_bust').focus()
		$('.SizeChart__recommendation').hide()
		$('.SizeChart__table th span').text(unitNext)
		$('.SizeChart tr').removeClass('SizeChart__row-highlighted')
		$('.SizeChart__cell').removeClass('SizeChart__cell_bold')
		$('.SizeChart__convert button').text('Convert to ' + unitNextName)
		$('.SizeChart__convert span').text('Measurements displayed in ' + unitCurrentName)
	}

	function initEvents() {
		$('.SizeChart__convert button').on('click', function () {
			convert()
		})

		$('.SizeChart__input').on('input', function () {
			var unit = $('.SizeChart').data('unit')
			var chart = getChart(getDesigner())
			var sizes = []
			function findMeasure (measure) {
				var value = $('.SizeChart__input_' + measure).val()
				if (value !== '') {
					for (var i = 0; i < chart.length; i++) {
						var dbValue = chart[i][measure]
						var convertedValue = (unit === 'cm') ? convertInchToCm(dbValue) : dbValue
						if (convertedValue >= value) {
							sizes.push(chart[i].size)
							$('.SizeChart__cell_' + measure).removeClass('SizeChart__cell_bold')
							$('.SizeChart__cell_' + measure + '[data-inches="' + dbValue + '"]').addClass('SizeChart__cell_bold')
							break
						}
					}
				}
			}
			findMeasure('bust')
			findMeasure('waist')
			findMeasure('hip')
			var re = /^[\d\.]+$/
			var maxSize = sizes.reduce(function(a, b) {
				return Math.max(a, b)
			})
			$('.SizeChart tr').removeClass('SizeChart__row-highlighted')
			if (
				re.test($('.SizeChart__input_bust').val()) &&
				re.test($('.SizeChart__input_waist').val()) &&
				re.test($('.SizeChart__input_hip').val())
			) {
				$('.SizeChart__recommendation').show()
				$('.SizeChart__recommendation span').text(maxSize)
				$('.SizeChart__cell_size[data-size="' + maxSize + '"]').closest('tr').addClass('SizeChart__row-highlighted')
			} else {
				$('.SizeChart__recommendation').hide()
			}
		})
	}

	function init(options) {
		var optionsDefault = {
			unit: 'inch'
		}
		var options = options || {}
		for (var key in options) {
			if (options.hasOwnProperty(key)) {
				optionsDefault[key] = options[key]
			}
		}
		var optionsFinal = optionsDefault

		var sizeChartContainer = document.querySelector('.SizeChartContainer')
		if (!sizeChartContainer) return false
		var designer = getDesigner()
		if (!designer) return false
		var chart = getChart(designer)
		if (!chart) return false
		sizeChartContainer.innerHTML = getHtml(designer, chart, (optionsFinal.unit === 'inch') ? 'cm' : 'inch')
		convert()
		initEvents()
	}

	return {
		init: init
	}
}())
CustomJS.SizeChart.init()

CustomJS.GeoRestriction = (function () {
	function getDesigners($nodeList) {
		var designers = []
		$nodeList.map(function () {
			var productName = $(this).text()
			var designer = productName.substring(0, productName.lastIndexOf(' '))
			designers.push(designer)
		})
		return designers
	}

	function render(designerLocations) {
		$.ajax({
			url: 'https://apps.nexusmedia-ua.com/geoip/',
			success: function (data) {
				var dataParsed = JSON.parse(data)
				if (!(dataParsed.country && dataParsed.country.iso_code) || !designerLocations) {
					$('.ProductForm__AddToCart').show();
					$('.shopify-payment-button').show();
					return
				}
				var message = '<p class="GeoRestriction__button button">This vendor isn\'t shipped to your country</p>'
				var isRestricted = false
				designerLocations.forEach(function (designerLocation) {
					if (dataParsed.country.iso_code == designerLocation) {
						isRestricted = true
					}
				})
				if (isRestricted) {
					$('.ProductForm__AddToCart').before(message)
					$('.ProductForm__AddToCart').hide();
					$('.shopify-payment-button').hide();
				} else {
					$('.ProductForm__AddToCart').show();
					$('.shopify-payment-button').show();
				}
			},
			error: function () {
				$('.ProductForm__AddToCart').show();
			}
		})
	}

	function renderCheckout(db, countryCode, designers) {
		if (!countryCode || !designers.length) return false
		var isRestricted = false
		var blamedDesigner = ''
		designers.forEach(function (designer) {
			var designerLocations = db[designer]
			if (!designerLocations) return false
			designerLocations.forEach(function (designerLocation) {
				if (countryCode == designerLocation) {
					isRestricted = true
					blamedDesigner = blamedDesigner || designer
				}
			})
		})
		
		var country_input = $('[data-address-field="country"]');

		if (isRestricted) {
			
			$('.step__footer__continue-btn').prop('disabled', true);
			
			country_input.addClass('field--error');
			country_input.find('.field__input-wrapper').append('<p class="field__message field__message--error" id="error-for-zip">Vendor <span>'+blamedDesigner+'</span> isn\'t shipped to selected country</p>');
		} else {
			
			$('.step__footer__continue-btn').prop('disabled', false);
			
			country_input.removeClass('field--error');
			country_input.find('.field__input-wrapper .field__message').remove();
		}
	}

	function init() {
		var db = CustomDB.GeoRestriction
		var $body = $('body')
		
		/*
		We dont have product quick-view
		if ($body.hasClass('collection') || $body.hasClass('search')) {
			$('body').on('click', '.product-modal', function () {
				var collectionInterval = setInterval(function () {
					if ($('.product-quick-view').length) {
						clearInterval(collectionInterval)
						var designers = getDesigners($('.product-quick-view .product-description h2').first())
						render(db[designers[0]])
					}
				}, 500)
			})
		} else */
		if ($body.hasClass('template-product')) {
			var designers = getDesigners($('.ProductMeta__Title').first())
			render(db[designers[0]])
		} else if (document.location.pathname.indexOf('checkout') !== -1) {
			var countryCode = $('#checkout_shipping_address_country option:selected').data('code')
			var designers = getDesigners($('.product__description__name'))
			renderCheckout(db, countryCode, designers)
			$('#checkout_shipping_address_country').on('change', function () {
				var countryCode = $(this).find('option:selected').data('code')
				var designers = getDesigners($('.product__description__name'))
				renderCheckout(db, countryCode, designers)
			})
		}
	}

	return {
		init: init
	}
}())
CustomJS.GeoRestriction.init()


CustomJS.ProductOptions = (function () {
	var sizemap = {};
	function checkConditions() {
		return jQuery('body').hasClass('template-product');
	}

	function render() {
		var clicked = false;
		var selected_value = jQuery('.ProductForm__OptionName:eq(0)').text().split(':')[1].substring(1, 1000).toLowerCase();
		
		jQuery('.Popover__Content:eq(1) .Popover__ValueList button').each(function() {
			var $this = jQuery(this);
			
			if (sizemap.hasOwnProperty(selected_value) && sizemap[selected_value].includes($this.data('value').toString())) {
				$this.show();
				
				if (!clicked) {
					$this.click(); clicked = true;
				}
			} else {
				$this.hide();
			}
		});
	}

	function addEvents() {
		jQuery('.ProductForm__OptionName:eq(0)').on('DOMSubtreeModified', function() {
			render();
		});
	}

	function init() {
		if (!checkConditions()) return
		
		product.variants.forEach(function(a){
			if (a.available) {
				sizemap[a.option1.toLowerCase()] = sizemap[a.option1.toLowerCase()] || [];
				sizemap[a.option1.toLowerCase()].push(a.option2);
			}
		});
		
		var clicked = false;
		jQuery('.Popover__Content:eq(0) .Popover__ValueList button').each(function() {
			if (sizemap.hasOwnProperty(jQuery(this).data('value').toLowerCase())) {
				if (!clicked) {
					clicked = true; 
					jQuery(this).click();
				}
			}else {
				jQuery(this).hide();
			}
		});
		
		
		console.log(sizemap);
		
		render()
		addEvents()
	}

	return {
		init: init
	}
}())
CustomJS.ProductOptions.init()

CustomJS.ReturnPolicyConfirmation = (function () {
	function initialRender() {
		$('.step__footer').before(
			'<div class="ReturnPolicyConfirmation">' +
				'<input class="ReturnPolicyConfirmation__checkbox input-checkbox" type="checkbox">' +
				'<span class="ReturnPolicyConfirmation__link">Agree to Return Policy terms</span>' +
				'<div class="ReturnPolicyConfirmation__popup ReturnPolicyConfirmation__popup_hidden">' +
					'<div class="ReturnPolicyConfirmation__popup-shadow"></div>' +
					'<div class="ReturnPolicyConfirmation__popup-window">' +
						'<div class="ReturnPolicyConfirmation__popup-close">&times;</div>' +
						'<p>Due to coVID-19 we will no longer be able to accept returns or exchanges until further notice.</p>' +
						'<p>ALL SALES ARE FINAL</p>' +
					'</div>' +
				'</div>' +
			'</div>'
		)
	}

	function toggleButton() {
		var $button = document.getElementsByClassName('step__footer__continue-btn')[0]
		var $checkbox = document.querySelector('.ReturnPolicyConfirmation__checkbox')
		$button.disabled = $checkbox.checked ? false : true
		$($button).toggleClass('btn--disabled')
	}

	function addEvents() {
		$('.ReturnPolicyConfirmation__checkbox').on('click', function () {
			toggleButton()
		})
		$('.ReturnPolicyConfirmation__link, .ReturnPolicyConfirmation__popup-shadow, .ReturnPolicyConfirmation__popup-close').on('click', function () {
			$('.ReturnPolicyConfirmation__popup').toggleClass('ReturnPolicyConfirmation__popup_hidden')
		})
	}

	function run() {
		initialRender()
		toggleButton()
		addEvents()
	}

	function init() {
		var condition = ($('.main__content .step').data('step') === 'payment_method')
		if (!condition) return
		var interval = setInterval(function () {
			if ($('.step__footer__continue-btn').length) {
				clearInterval(interval)
				run()
			}
		}, 50)
	}

	return {
		init: init
	}
}())
CustomJS.ReturnPolicyConfirmation.init()

// WearDate START
CustomJS.WearDate = (function () {
	function getExcludedDays() {
		/*
		list of shipping methods (not full, just example):
		DAYS METHOD                                  CITY     ZIP
		14   DHL Express (1 business day)            Ottawa   K1A 0B1
		14   DHL Express (3 business days)           Paris    75001
		14   DHL Express (4 business days)           Moscow   101000
		14   Flat Rate UK Shipping                   London   W1S 1DW
		14   Free Shipping                           New York 10001
		14   UPS Ground                              New York
        9    FedEx Ground Home Delivery              New York
		5    UPS Three-Day Select (3 business days)  New York
		4    UPS Second Day Air (2 business days)    New York
        4    FedEx 2 Day                             New York
		3    UPS Next Day Air Saver (1 business day) New York
        3    FedEx Standard Overnight                New York
		14   UPS Worldwide Expedited                 non-USA
        10   FedEx International Economy             non-USA
        9    FedEx International Priority            non-USA
		*/
		var days = 0
		var id = $('[name="checkout[shipping_rate][id]"]:checked').attr('id')
		var text = $('[for="' + id + '"]').text().trim().toLowerCase()
		var business = text.match(/(\d) business/)
		if (
			text.indexOf('fedex') >= 0
			|| text.indexOf('FedEx International Economy') >= 0
			|| text.indexOf('ups worldwide expedited') >= 0
			|| text.search(/ground/) >= 0
		) {
			days = 16
		} else if (
			text.indexOf('free shipping') >= 0
			|| text.indexOf('ups worldwide express') >= 0
			|| text.indexOf('ups worldwide express plus') >= 0
		) {
			days = 12
		} else if (business) {
			days = Number(business[1]) + 2
		}
		return days
	}

	function setCartNote() {
		var date = $('.WearDate__input').val()
		if (!date) return
		var message = 'Wear date: ' + date
		var $cartNote = $('.WearDate__cart-note')
		var text = $cartNote.text()
		if (text.indexOf('Wear date') < 0) {
			if (text.lastIndexOf('\n') !== text.length - 1) {
				text += '\n'
			}
			text += message
		} else {
			text = text.replace(/Wear date: \d+\/\d+\/\d+/, message)
		}
		$cartNote.val(text)
	}

	function toggleCheckoutButton() {
		var buttonClass = 'btn--disabled'
		var $button = $('.step__footer__continue-btn')
		if (/^\d{2}\/\d{2}\/\d{4}$/.test($('.WearDate__input').val())) {
			$button.removeClass(buttonClass)
		} else {
			$button.addClass(buttonClass)
		}
	}

	function checkConditions() {
		return $('.main__content .step').data('step') === 'shipping_method'
	}

	function renderWidget() {
		$('.step__footer').before(
			'<div class="WearDate">' +
				'<div class="WearDate__wrapper">' +
					'<h3 class="WearDate__title">Wear date</h3>' +
					'<p class="WearDate__link">What is a wear date?</p>' +
					'<input class="WearDate__input field__input" type="text" placeholder="mm/dd/yyyy" readonly>' +
				'</div>' +
				'<textarea class="WearDate__cart-note" name="checkout[note]"></textarea>' +
				'<div class="WearDate__popup WearDate__popup_hidden">' +
					'<div class="WearDate__popup-shadow"></div>' +
					'<div class="WearDate__popup-window">' +
						'<div class="WearDate__popup-close">&times;</div>' +
						'<p>Your wear date is the latest date you agree to accept your order.</p>' +
						'<p>Please select your wear date from the calendar. If the date is not available, you can upgrade your shipping method for earlier dates.</p>' +
						'<p>If we cannot deliver your order by this wear date you will be notified by a DressWarehouse Representative.</p>' +
          				'<p><b><br>Please note some orders may be affected by coVID-19 due to warehouse closures. At this time our team is contacting all orders to ensure you have all the relevant information about how/if your order is affected.</b></p>' +
          				'<p><br><a href="https://www.newyorkdress.com/pages/contact-us" target="blank">If you still have any questions about your order and if it is affected click here to contact us</a></p>' +
					'</div>' +
				'</div>' +
			'</div>'
		)
	}

	function cartNotePrefill() {
		$.getJSON('/cart.js', function (data) {
			$('.WearDate__cart-note').text(data.note)
		})
	}

	function initDatepicker() {
		if (typeof $.fn.datepicker === 'undefined') return
		var interval = setInterval(function () {
			if (document.querySelector('[name="checkout[shipping_rate][id]"]:checked')) {
				$('.WearDate__input').datepicker({
					minDate: getExcludedDays(),
					numberOfMonths: 3,
					showButtonPanel: true
				})
				clearInterval(interval)
			}
		}, 100)
	}

	function addEvents() {
		$('.WearDate__link, .WearDate__popup-shadow, .WearDate__popup-close').on('click', function () {
			$('.WearDate__popup').toggleClass('WearDate__popup_hidden')
		})
		$('.WearDate__input').on('input change', function () {
			setCartNote()
			toggleCheckoutButton()
			$('.WearDate__input').removeClass('WearDate__input_invalid')
		})
		$('.section__content').on('change', '[name="checkout[shipping_rate][id]"]', function () {
			var days = getExcludedDays()
			$('.WearDate__input')
				.datepicker('option', 'minDate', days)
				.datepicker('refresh')
			setCartNote()
		})
		// disable checkout button in response to the rerender after cart update:
		$('.step__footer').on('DOMSubtreeModified', function () {
			setTimeout(function () {
				toggleCheckoutButton()
			}, 100)
		})
		$('body').on('click', '.step__footer__continue-btn', function () {
			setCartNote()
			var $input = $('.WearDate__input')
			var inputClass = 'WearDate__input_invalid'
			if (/^\d{2}\/\d{2}\/\d{4}$/.test($input.val())) {
				$input.removeClass(inputClass)
				return true
			} else {
				$input.addClass(inputClass)
				return false
			}
		})
	}

	function init() {
		if (!checkConditions()) return
		renderWidget()
		cartNotePrefill()
		initDatepicker()
		toggleCheckoutButton()
		addEvents()
	}

	return {
		init: init
	}
}())
CustomJS.WearDate.init()
// WearDate END

CustomJS.PreOrder = (function () {
	function updateView() {
		var designer = document.location.pathname.split('-');
		designer = designer[designer.length-1];
      var designer2 = document.location.pathname.split('-')[0].split('/');
      designer2 = designer2[designer2.length-1];
      
		var model = jQuery('.ProductForm__Option button:eq(0)').text().split(':')[1].trim().toLowerCase();
		var size = jQuery('.ProductForm__Option button:eq(1)').text().split(':')[1].trim().toLowerCase()
		
		jQuery('.PreOrder__message').hide();
		
		preorder_dates.forEach(function(a) {

			if (a[0] == [designer,model, size].join('-').replace('/', '-') && isDateStale(a[1])) {
              	window.product_preorder_str = designer2 +'-'+ [designer,model, size].join('-').replace('/', '-') + ' - Ready to ship by ' + a[1];
				jQuery('.PreOrder__message').show();
				jQuery('.PreOrder__message span').text(a[1]);
				jQuery('.PreOrder__popup-content .date').text(a[1]);
			}
		});
      
      	jQuery('.ProductForm__AddToCart').off('click.preorder');
      	jQuery('.ProductForm__AddToCart').on('click.preorder',function(){console.log('asdasdasd');
			if (jQuery('.PreOrder__message:visible').length == 0) return;
			jQuery('.PreOrder__popup').toggleClass('PreOrder__popup_hidden')
            var products = localStorage.getItem('po_products');
            products = JSON.parse(products);
            if (products == null || Array.isArray(products)) products = {};
                                                                         
            products[$('[title="Variant"] option:selected').val()] = window.product_preorder_str;
            localStorage.setItem('po_products', JSON.stringify(products));                                                             
		});
	}

	function addEvents() {
		jQuery('body').on('DOMSubtreeModified', '.ProductForm__Option ', function () {
			updateView()
		}).on('click', '.PreOrder__popup-shadow, .PreOrder__popup-close, .PreOrder__popup button' , function (e) {
			e.preventDefault()
			
			if (jQuery('.PreOrder__message:visible').length == 0) return
			jQuery('.PreOrder__popup').toggleClass('PreOrder__popup_hidden')
		});

	}

	function isDateStale(date) {
		var parts = date.split('/')
		var year = Number(parts[2])
		var month = Number((parts[0].indexOf('0') === 0) ? parts[0].charAt(1) : parts[0])
		var day = Number((parts[1].indexOf('0') === 0) ? parts[1].charAt(1) : parts[1])
		var now = new Date()
		var yearNow = now.getFullYear()
		var monthNow = (now.getMonth() + 1)
		var dayNow = now.getDate()
		if (
			year > yearNow
			|| (year === yearNow && month > monthNow)
			|| (year === yearNow && month === monthNow && day > dayNow)
		) {
			return true
		}
		return false
	}



	function init() {
		
		updateView();
		addEvents();
	}

	return {
		init: init
	}
}())
CustomJS.PreOrder.init();

